import {
    Box,
    FormControl,
    FormLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    TextField,
    InputLabel,
    Typography,
    Button,
    FormHelperText,
  } from "@mui/material";
  import validator from "email-validator";
  import { PhoneNumberUtil } from "google-libphonenumber";
  import { useEffect, useState } from "react";
  import { useSelector } from "react-redux";
  import store, { RootState } from "../../../store/store";
  import { LoadingButton } from "@mui/lab";
  import { IAddParty } from "../../../shared/models/settings";
  import { getUserContext } from "../../../shared/utils/utils";
  import {
    ADMIN_ROLES,
      APPROVAL_NAME_MAPPING,
    PARTY_ACTIVE_STATUS,
    ROLE_MAPPING,
  } from "../../../shared/constants/constants";
import { updateParty, updatePartyContactMech } from "../../../store/api/party";
import { fetchAllSecurityGroups } from "../../../store/api/common";
import { getPartyContactDetails } from "../../../store/api/order";

  type Props = {
    cancelEdit: () => void;
    editUser: (reqBody: any) => void;
    handleSetError:(message:string)=>void;
    handleSetSuccess:(message:string)=>void;
    user:any
  };
  const phoneUtil = PhoneNumberUtil.getInstance();
  export const EditUser = ({ user, cancelEdit, editUser,handleSetError,handleSetSuccess }: Props) => {
    const settingsRfqState = useSelector((state: RootState) => state.settings);
    const storePartyState = useSelector((state: RootState) => state.party);
    // const [roles,setRoles] = useState(["Buyer Admin","Buyer Approver","Accounts","Custom Role"])
    const userContext: any = getUserContext();
    const orgPartyId = userContext.orgPartyIds[0];
    // console.log(orgPartyId)
    const [name, setName] = useState({
      value: user?.details?.name,
      isError: false,
      errorMsg: "",
    });
    const [role, setRole] = useState({
      value: user.roles[0],
      isError: false,
      errorMsg: "",
    });
    const [level, setLevel] = useState({
      value: APPROVAL_NAME_MAPPING[user.roles[1]?.toUpperCase() as keyof typeof APPROVAL_NAME_MAPPING],
      isError: false,
      errorMsg: "",
    });
    const [email, setEmail] = useState({
      value: user.email,
      isError: false,
      errorMsg: "",
    });
    const [phoneNumber, setPhoneNumber] = useState({
      value: user.phone,
      isError: false,
      errorMsg: "",
    });
    const [roles, setRoles] = useState([]);
  useEffect(()=>{
    store.dispatch(fetchAllSecurityGroups()).unwrap().then((res)=>{
      if(res.status===200){
        setRoles(res.data);
      }
    })
  },[])
  
    useEffect(() => {
      user &&
        user?._id &&
        store
          .dispatch(getPartyContactDetails(user?._id))
          .unwrap()
          .then((res: any) => {
            const emailTemp = res?.data?.filter(
              (con: any) => con?.purposeType[0] === "PRIMARY_EMAIL" && !con?.thruDate
            );
            const phoneTemp = res?.data?.filter(
              (con: any) => con?.purposeType[0] === "PRIMARY_PHONE" && !con?.thruDate
            );
            setEmail({ ...email, value: emailTemp[0] });
            setPhoneNumber({ ...phoneNumber, value: { ...phoneTemp[0], detail: phoneTemp[0]?.detail?.slice(-10) } });
          });
    }, [user]);
    const handleLevelChange = (event: SelectChangeEvent) => {
      // console.log(event.target.value)
      setLevel((prevState) => ({
        ...prevState,
        value: event.target.value,
      }));
    };
    const handleRoleChange = (event: SelectChangeEvent) => {
      // console.log(event.target.value)
      setRole((prevState) => ({
        ...prevState,
        value: event.target.value,
      }));
    };
    const validateName = (name: string) => {
      if (name.length < 2) {
        setName((prevState) => ({
          ...prevState,
          isError: true,
          errorMsg: "Please enter a valid name",
        }));
        return false;
      } else {
        setName((prevState) => ({
          ...prevState,
          isError: false,
          errorMsg: "",
        }));
        return true;
      }
    };
    const validateRole = (role: string) => {
      if (role === "Select Role") {
        setRole((prevState) => ({
          ...prevState,
          isError: true,
          errorMsg: "Please select a role",
        }));
        return false;
      } else {
        setRole((prevState) => ({
          ...prevState,
          isError: false,
          errorMsg: "",
        }));
        return true;
      }
    };
    const validateLevel = (level: string) => {
      if (level === "Select Level") {
        setLevel((prevState) => ({
          ...prevState,
          isError: true,
          errorMsg: "Please select a level",
        }));
        return false;
      } else {
        setLevel((prevState) => ({
          ...prevState,
          isError: false,
          errorMsg: "",
        }));
        return true;
      }
    };
    const validateEmail = (email: string) => {
      if (!validator.validate(email)) {
        setEmail((prevState) => ({
          ...prevState,
          isError: true,
          errorMsg: "Please enter a valid email",
        }));
        return false;
      } else {
        setEmail((prevState) => ({
          ...prevState,
          isError: false,
          errorMsg: "",
        }));
        return true;
      }
    };
    const validatePhone = (number: string) => {
      try {
        if (phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(number))) {
          setPhoneNumber((prevState) => ({
            ...prevState,
            isError: false,
            errorMsg: "",
          }));
          return true;
        } else {
          setPhoneNumber((prevState) => ({
            ...prevState,
            isError: true,
            errorMsg: "Please enter a valid phone number",
          }));
          return false;
        }
      } catch {
        setPhoneNumber((prevState) => ({
          ...prevState,
          isError: true,
          errorMsg: "Please enter a valid phone number",
        }));
        return false;
      }
    };

    const handleUpdateUser = async () => {
      const number = `+91${phoneNumber.value?.detail?.toString()}`;
      if (
        validateName(name.value) &&
        validateRole(role.value) &&
        validateEmail(email.value?.detail) &&
        validateLevel(level.value) &&
        validatePhone(number)
      ) {
        //Call API
        // console.log(role.value);
        const reqBody = {
          name: name.value,
          personRole: [role.value,level.value],
          emailAddress: email.value?.detail,
          mobileNumber: number,
          address: "",
          city: "",
          gstNumber: "",
          panNumber: "",
          partyGroupName: "",
          partyGroupRole: "",
          partyTypeId: "PERSON",
          password: "",
          pincode: "",
          state: "",
          tinNumber: "",
          statusId:PARTY_ACTIVE_STATUS,
          partyId:user._id,
        };
        const updateEmailReqBody = {
          partyContactMechId: email?.value?._id,
          contactmechType: email?.value?.contactmechType,
          purposeType: email?.value?.purposeType,
          detail: email?.value?.detail
        }
        const updateMobileReqBody = {
          partyContactMechId: phoneNumber?.value?._id,
          contactmechType: phoneNumber?.value?.contactmechType,
          purposeType: phoneNumber?.value?.purposeType,
          detail: number
        }
        // console.log(reqBody);
  
        await Promise.allSettled(
          [
            store.dispatch(updateParty(reqBody)).unwrap().then((res: any) => {
              if(res.status===200) {
                handleSetSuccess("Successfully updated the user details.");
                editUser(res.data)
                return res.data;
              }
              else {
                // handle error when user is not created
                handleSetError(res.error)
              }
            })
            .catch((error: any)=>{
              handleSetError(error)
            }),
            store.dispatch(updatePartyContactMech(updateEmailReqBody)).unwrap().then((res: any) => {
              if(res.status===200) {
                handleSetSuccess("Successfully updated the user email.");
                return res.data;
                // editUser(res.data)
              }
              else {
                handleSetError(res.error)
              }
            })
            .catch((error: any)=>{
              handleSetError(error)
            }),
            store.dispatch(updatePartyContactMech(updateMobileReqBody)).unwrap().then((res: any) => {
              if(res.status===200) {
                handleSetSuccess("Successfully updated the user phone.");
                return res.data;
                // editUser(res.data)
              }
              else {
                handleSetError(res.error)
                // console.log(res.error)
              }
            })
            .catch((error: any)=>{
              handleSetError(error)
            })
          ]
        )
        
      }
    };

    return (
      <>
        <Box className="addUserBox">
          <Box className="addUserFormsContainer">
            <FormControl
              fullWidth
              sx={{ mt: 2 }}
              variant="standard"
              className="addUser_input_field"
            >
              <FormLabel>Name</FormLabel>
              <TextField
                id="Name"
                variant="standard"
                placeholder="Full Name"
                value={name.value}
                error={name.isError}
                helperText={name.errorMsg}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setName((prevState) => ({
                    ...prevState,
                    value: event.target.value,
                  }));
                }}
                className="addUserinput_text"
              />
            </FormControl>
          </Box>
          <Box className="addUserFormsContainer">
            <FormControl
              fullWidth
              sx={{ mt: 2, width: { xs: "100%", md: "40%" } }}
              variant="filled"
              className="addUser_input_field"
            >
              <FormLabel>Role</FormLabel>
              <Select
                labelId="select-role"
                id="select-role"
                value={role.value}
                onChange={handleRoleChange}
                className={role.value === "Select Role" ? "baseSelect" : ""}
                error={role.isError}
              >
                <MenuItem value={"Select Role"} disabled>
                  Select Role
                </MenuItem>
                {roles?.filter((role:any)=>!ADMIN_ROLES?.includes(role?.groupId) && !role?.groupId?.includes("VENDOR") && (!role?.partyId || role?.partyId === orgPartyId)).map((role: any, index: any) => {
                return (
                  <MenuItem value={role.groupId} key={role._id}>
                    {role.groupName}
                  </MenuItem>
                );
              })}
              </Select>
              <FormHelperText sx={{ color: "red" }}>
                {role.errorMsg}
              </FormHelperText>
            </FormControl>
  
            <FormControl
              variant="filled"
              sx={{ mt: 2, width: { xs: "100%", md: "40%" } }}
              className="addUser_input_field"
            >
              <FormLabel>Level</FormLabel>
  
              <Select
                labelId="select-role"
                id="select-role"
                value={level.value}
                onChange={handleLevelChange}
                className={level.value === "Select Level" ? "baseSelect" : ""}
                error={level.isError}
              >
                <MenuItem value={"Select Level"} disabled>
                  Select Level
                </MenuItem>
                <MenuItem value={APPROVAL_NAME_MAPPING.L1_APPROVER}>L1</MenuItem>
                <MenuItem value={APPROVAL_NAME_MAPPING.L2_APPROVER}>L2</MenuItem>
                <MenuItem value={APPROVAL_NAME_MAPPING.L3_APPROVER}>L3</MenuItem>
                {/* <MenuItem value={APPROVAL_NAME_MAPPING.L4_APPROVER}>L4</MenuItem> */}
                {/* <MenuItem value={APPROVAL_NAME_MAPPING.L5_APPROVER}>L5</MenuItem> */}
              </Select>
              <FormHelperText sx={{ color: "red" }}>
                {level.errorMsg}
              </FormHelperText>
            </FormControl>
          </Box>
          <Box className="addUserFormsContainer">
            <FormControl
              fullWidth
              sx={{ mt: 2 }}
              variant="standard"
              className="addUser_input_field"
            >
              <FormLabel>E-mail</FormLabel>
              <TextField
                id="email"
                variant="standard"
                type="email"
                placeholder="Email"
                value={email.value?.detail}
                error={email.isError}
                helperText={email.errorMsg}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setEmail((prevState) => ({
                    ...prevState,
                    value: {
                      ...email?.value,
                      detail: event.target.value
                    }
                  }));
                }}
                className="addUserinput_text"
              />
            </FormControl>
            <Box
              sx={{
                width: { xs: "100%", md: "40%" },
                display: "flex",
                flexDirection: "column",
                justifyContent: "end",
              }}
            >
              <FormLabel className="addUserPhoneNumberLabel">
                Phone number
              </FormLabel>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  gap: "20px",
                }}
              >
                <Typography className="addUserinput_typography">+ 91</Typography>
                <FormControl
                  fullWidth
                  sx={{ width: "100% !important" }}
                  variant="standard"
                  className="addUser_input_field"
                >
                  <TextField
                    id="phoneNumber"
                    variant="standard"
                    placeholder="Phone Number"
                    type="number"
                    value={phoneNumber.value?.detail}
                    error={phoneNumber.isError}
                    helperText={phoneNumber.errorMsg}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      setPhoneNumber((prevState) => ({
                        ...prevState,
                        value: {
                          ...phoneNumber?.value,
                          detail: event.target.value
                        }
                      }));
                    }}
                    className="addUserinput_text"
                  />
                </FormControl>
              </Box>
            </Box>
          </Box>
          <Box className="addUserBtnsContainer">
            <LoadingButton
              loadingPosition="center"
              variant="contained"
              className="addNewUserBtn"
              onClick={handleUpdateUser}
              disabled={settingsRfqState.loading || storePartyState.loading}
              loading={storePartyState.loading}
            >
              Update user
            </LoadingButton>
            <Button
              variant="contained"
              className="addNewUserBtn"
              onClick={cancelEdit}
              sx={{
                backgroundColor: "#F0F0F0 !important",
                color: " #22438C !important",
              }}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </>
    );
  };
  